import { ReactNode } from 'react'

import Picture from '../picture'

interface Props {
  heading: string
  image: string
  description: string
  reverse?: boolean
  children?: ReactNode
}

const DetailedFeatureRow = ({
  heading,
  image,
  description,
  children,
  reverse = false,
}: Props) => (
  <section className="md:grid md:grid-cols-2 md:gap-x-[30px] md:items-center md:mt-[132px] py-[15px]">
    <p className="text-[28px] text-[#101010] leading-[1.1875] font-medium font-natosans-medium md:hidden pt-5 pb-2.5">
      {heading}
    </p>
    <Picture
      image={image}
      imageAlt={heading}
      aria-hidden
      role="presentation"
      pictureStyle={`${reverse ? 'md:order-2' : ''} flex justify-center`}
      imageStyle="mt-4 block max-h-[430px]"
    />
    <article className={reverse ? 'md:order-1' : ''}>
      <p className="text-[44px] text-[#101010] leading-[1.1875] font-medium font-natosans-medium mt-5 hidden md:block">
        {heading}
      </p>
      <p className="whitespace-pre-wrap mt-4 mb-2.5 text-lg leading-[1.6] text-neutral-80 font-natosans-light font-light">
        {description}
      </p>
      {children}
    </article>
  </section>
)

export default DetailedFeatureRow
